export default __webpack_public_path__ + "static/media/MS001.096f20e5.mp3";